<div class="modal-header">
    {{ title }}
</div>

<div class="modal-body">

    <form [formGroup]="form" [class.show-form-error]="showFormError">
        <div class="field-panel form-group">
            <div class="field-title">
                Username
            </div>
            <div *ngIf="userName" class="field-label">
                {{ userName }}
            </div>
        </div>
        <div class="field-panel form-group">
            <div class="field-title">
                Company Group
            </div>
            <div *ngIf="companyGroupName" class="field-label">
                {{ companyGroupName }}
            </div>
        </div>
        <div class="field-panel form-group">
            <div class="field-title">
                Company
            </div>
            <div *ngIf="companyName" class="field-label">
                {{ companyName }}
            </div>
        </div>
        <div class="field-panel form-group">
            <div class="field-title field-title-required">
                New Password
            </div>
            <div class="field-holder">
                <input
                    type="password"
                    class="form-control"
                    formControlName="newPassword"
                    maxlength="20"
                    required
                    />
                    <div class="error-msg mt-1" *ngIf="newPassword.errors?.required && showFormError">
                            Please enter your new password
                    </div>
            </div>
        </div>
        <div class="field-panel form-group">
            <div class="field-title field-title-required">
                Confirm New Password
            </div>
            <div class="field-holder">
                <input
                    type="password"
                    class="form-control"
                    formControlName="confirmNewPassword"
                    maxlength="20"
                    required
                    />
                    <div class="error-msg mt-1" *ngIf="confirmNewPassword.errors?.required && showFormError">
                            Please confirm your new password
                    </div>
            </div>
        </div>
        <div class="error-msg mt-1 ml-2" *ngIf="form.errors?.notMatch && showFormError">
            New Password and Confirm Password are not matched, please check.
        </div>
    </form>

    <div class="buttons">
        <button type="button" class="btn btn-cancel" aria-label="Cancel" (click)="cancel()">Cancel</button>
        <button type="button" class="btn btn-primary ok" aria-label="OK" (click)="submitResetPassword()">Confirm</button>
    </div>
 
</div>
